import { applyVueInReact } from 'vuereact-combined';

import UpgradeMultiplePlansPayment from '@/components/dialogs/UpgradeMultiplePlansDialog/UpgradeMultiplePlansPayment.vue';
const ReactUpgradeMultiplePlansPayment = applyVueInReact(UpgradeMultiplePlansPayment);
const SettingsUsageBillingAddPaymentMethodBox = () => (
	<ReactUpgradeMultiplePlansPayment purchaseProduct={false} prefillDefaultPaymentMethod={false} buttonText={'Add Payment Method'} />
);

export default SettingsUsageBillingAddPaymentMethodBox;
